<template>
  <div class="home">

   <div class="home-ct">
	   <div class="product">
		   <div class="product-st">
			   <div class="pic">
				  <div class="l1">
				
					 <div class="block">
						 <el-carousel trigger="click" @change="carou" ref="carousel" :initial-index='ride' height="400px" autoplay=false>
					       <el-carousel-item v-for="item in news.images" :key="item">
							   <img :src="item" />
					   
					       </el-carousel-item>
					     </el-carousel>
					   </div>
				  </div>
				  <div class="l2">
					  <ul>
						<li :class="{'item-acticve':ride == index}"  @click="nood(index)" v-for="(item,index) in news.images"><img :src="item"/></li>
					  </ul>
				  </div>
			   </div>
			    <div class="txt">
					<h2>{{news.title}}</h2>
					<div class="l3" v-if="news.kucun==0"><img src="../../assets/stock.png"></div>
					<div class="l4">
						{{news.jifen}} points
					
					</div>
					<div class="l5">
						<!-- <el-input-number size="mini"  v-model="num" @change="handleChange" :min="1" :max="news.kucun" ></el-input-number> -->
						 <div class="cart-but" @click="sandYart">Redeem now</div>
					</div>
					<div class="l6" v-html="news.remark">
						
					</div>
				
				</div>
		   </div>
		   <div class="product-bt">
			 <div class="tit">
				Redeem now
			 </div>
		
			<div class="con" v-html="news.content">
			 			
			 </div>
			
		   </div>
	<!-- 	   <div class="product-bt">
			   <div class="tit relat">
				相關產品
			   </div>
			   <div>
				   
				   
				   	   <div class="home-arr">
				   		   
				   	   
				   	   	   <div class="con">
				   	   		   <ul>
				   				
				   	   				   <li v-for="it in pro" @click="product(it.inventoryId)">
				   						    <router-link :to="'/product/details?id='+it.inventoryId">
				   						  
				   						 
				   						   
				   						   <img class="fit" v-if="it.kucun==0" src="../../assets/sold_out.png" />
				   						   <div class="pic">
				   							   <img :src="it.img" />
				   						   </div>
				   						   <div class="txt">
				   							   <p>
				   {{it.title}}</p>
				   						  
				    <p class="time">
				   ¥ {{it.price_sale}} </p>
				    
				   						   </div>
				   	   					</router-link>		 
				   	   				   </li>
				   				<div class="clear"></div>
				   																	
				   	   				 
				   	   			   </ul>
				   				 
				   	   	   </div>
				   	   </div>
			   </div>
			   
		   </div> -->
		   
		
		   
		  
	   </div>
	   <div v-if="cart">
		   <div class="brand" ></div>
	   <div class="cart">
		<div class="cart-tit">
			<h4>購物車</h4>
			<div class="cr" @click="cart=false">CLOSE<img src="../../assets/arr.png"  /></div>
			
					</div>
					<div class="cart-con">
						<ul>
							<li v-for="item in roll">
								<div class="lt">
								<div class="pic">
									<img :src="item.image" />
								</div>
								<div class="txt">
									<p><b>{{item.title}}</b></p><p>{{item.num}}× <b>¥ {{item.price_sale}}</b></p>
								</div>
								</div>
								<div class="clo" @click="bit(item)">
									<img src="../../assets/arr.png" />
								</div>
							</li>
						
					</ul>
					</div>
					
					<div class="cart-bot">
						<div class="l1">
							<h4>小計:</h4>
							<h4>¥{{price}}</h4>
						</div>
						<div class="l2">
							<router-link to="/product/cart"><div class="h-button cart-but">查看購物車</div></router-link>
							<router-link to="/product/order"><div class="h-button cart-but">結帳</div></router-link>
						</div>
					</div>
		   
	   </div></div>
   </div>
   
   <el-dialog
     title="TIPS"
     :visible.sync="dialogVisible"
     width="30%">
     <p>積分可兌換購物券，可先購買</p>
	 <p>或者在 {{ticket.startTime}} 北京时間</p>
     <span slot="footer" class="dialog-footer">
       <el-button @click="dialogVisible = false">取消</el-button>
       <el-button type="primary" @click="voucher">交換</el-button>
     </span>
   </el-dialog>
    </div>
</template>
<script>


export default {

  data() {
    return {
		
		id:'',
		dialogVisible: false,
		ride:0,
		num: 1,
		info:'',
		news:[],
		notice:[],
		cart:false,
		roll:'',
		price:0,
		ticket:'',
		pro:''
		
    
    };
  },  mounted() {
	  
	  this.id = this.$route.query.id;
	
		this.sandMate();
	
		this.sandCart();
		},methods: {
			
			carou(e){
				this.ride=e
			},
			nood(index){
				this.$refs.carousel.setActiveItem(index)
			},
			
			sandMate(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=money_jifenPdtInfo",
				  data: {id:this.id},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==1){
						let arr=[]
						this.news=data.data;
						const reges = new RegExp('type="video/x-ms-asf-plugin" width="550" height="400" autostart="false" loop="true" />', 'gi')
						this.news.content=this.news.content.replace(/\<embed/gi, '<video width="700" height="470" controls loop><source')
						this.news.content=this.news.content.replace(reges, 'type="video/mp4"></video>')
					const regex = new RegExp('<img', 'gi')
					this.news.content = this.news.content.replace(regex, `<img style="margin-bottom:20px"`)
						this.news.images.forEach((item, index) => {
							if (index<4) {
								arr.push(item)
							}
						})
						this.news.images=arr
						if(this.news.ticket_info.had_ticket==0){
							
							this.dialogVisible=true
							this.ticket=this.news.ticket_info
							
							
						}
						
						this.sandCase(this.news.channelId)
					}
				 
				});
			
			},sandCase(id){
				
				this.$axios({
				  method: "post",
				  url: "service.php?action=product_plist",
				  data: {pagenum:4,channel_id:id},  
				}).then((res) => {
					let data=res.data;
							
					if(data.code==1){
				
										
						this.pro=data.data;
					
						
					}
				 
				});
				
			},collect(it){
			
							if(window.localStorage.getItem('user')== "undefined"||!window.localStorage.hasOwnProperty('user')){
								  this.$router.push({ path: "/login" });	
								return
							}
							this.$axios({
							  method: "post",
							  url: "service.php?action=product_collect",
							  data: {inventoryId:this.id,collect_type:it},  
							}).then((res) => {
								let data=res.data;
								
								if(data.code==1){
									this.$message.success(data.message);
									this.sandMate();
								
								}else{
									this.$message.error(data.message);
								}
							 
							});
						},sandCart(){
				this.price=0;
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_lists",
				  data: {},  
				}).then((res) => {
					let data=res.data;
					
					
					if(data.code==1){
						this.roll=data.data;
						
						this.roll.forEach((item, index) => {
						
						
							this.price =this.price+item.price_sale * item.num
							
						})
						this.price=this.price.toFixed(2)
					}
				 
				});
			},
			product(id){
				this.id=id;
				this.sandMate();
			},
			voucher(){
			
							this.$axios({
							  method: "post",
							  url: "service.php?action=money_createTicket",
							  data: {ticket_id:this.ticket.id},  
							}).then((res) => {
								let data=res.data;
								
								if(data.code==1){
									this.$message.success(data.message);
									this.dialogVisible=false
									this.sandMate();
								
								}else{
									this.$message.error(data.message);
									this.dialogVisible=false
								}
							 
							});
						},
			sandYart(){
				if(window.localStorage.getItem('user')== "undefined"||!window.localStorage.hasOwnProperty('user')){
					  this.$router.push({ path: "/login" });	
					return
				}
				if(this.news.ticket_info.had_ticket==0){
					
					this.dialogVisible=true
					return
					
				}
			
			let arr = [{
								image: this.news.images[0],
								title: this.news.title,
								price_sale:this.news.jifen,
								num: this.num
							}]
				let product_info = [{
					"inventoryId": this.news.inventoryId,
					"productId": this.news.productId,
					"num": this.num
				}]
								 localStorage.setItem("product_info", JSON.stringify(product_info));
			localStorage.setItem("order_info", JSON.stringify(arr));
			this.$router.push({ path: "/product/ord?id="+this.news.inventoryId });	
							 
			
			
			
			},bit(item){
				
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_del",
				  data: {inventoryId:item.inventoryId},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==1){
						this.$message.success(data.message);
						
						this.sandCart()
					}else{
						this.$message.error(data.message);
					}
				 
				});
			}
		}
};
</script>
<style lang="scss" scoped>
	.h-button{
		text-align: center;
		cursor: pointer;	
		padding: 0 50px;
		height: 50px;
		line-height: 50px;
		background: #000;
		color: #FFFFFF;
	}
	.h-button:hover{
		background-color: #333333;
	}
	.cart{
		position: fixed;
		top: 0;
		right: 0;
		background: #FFFFFF;
		width: 354px;
		height: 100%;
		border: 1px solid #eeeeee;
		z-index: 1000;
		.cart-tit{
			font-size: 16px;
			height:70px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 20px;
			border-bottom: 1px solid #eeeeee;
			h4{
				font-size: 20px;
			}
			.cr{
				font-size: 14px;
			}
			img{
				width: 11px;
				height: 10px;
				margin-left: 20px;
			}
		}
		.cart-but{
			margin-top: 20px;
		}
		.cart-con{
			margin-bottom: 100px;
			li{
				padding: 20px;
				display: flex;
				border-bottom: 1px solid #eeeeee;
				justify-content: space-between;
				.pic{
					width: 115px;
					height: 77px;
					img{
						width: 100%;
						height: 100%;
					}
				}
				.txt{
					font-size: 14px;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					margin-left: 10px;
				
				}
				.lt{
					display: flex;
				}
				
				
			}
		}
		.cart-bot{
			position: absolute;
			width: 314px;
			bottom: 0;
			padding: 20px;
			border-top: 1px solid #eeeeee;
			.l1{
				display: flex;
				justify-content: space-between;
				font-size: 20px;
				color: #2D2A2A;
			}
			.l2{
				font-size: 16px;
			}
		}
	}
	.brand{
		  position:fixed;left:0px;top:0px;
		    background:rgba(0, 0, 0, 0.7);
		    width:100%; 
		    height:100%;
		    filter:alpha(opacity=70);  
		    opacity:0.7;  
		    z-Index:999;  
	}
	.el-carousel__item h3 {
	    color: #475669;
	    font-size: 14px;
	    opacity: 0.75;
	    line-height: 150px;
	    margin: 0;
	  }
	
	  .el-carousel__item:nth-child(2n) {
	     background-color: #99a9bf;
	  }
	  
	  .el-carousel__item:nth-child(2n+1) {
	     background-color: #d3dce6;
	  }
.product{
	.product-st{
		border-bottom: 1px solid #dedede;
		display: flex;
		padding: 40px 0;
		.item-acticve{
			background: #333333;
		}
		.pic{
			width: 613px;
			.l1{
				img{
					width: 613px;
					height: 410px;
				}
				margin-bottom: 10px;
			}
			.l2{
				
				ul{
					li{
						width: 140px;
						height: 98px;
						float: left;
						margin-right: 9px;
						padding: 3px;
						img{
							width: 140px;
							height: 98px;
						}
					}
					li:last-child
					{ 
					margin-right: 0;
					}

					
				}
				
			}
		}
		.txt{
			padding: 20px 40px;
			h2{
				font-size: 28px;
			}
			.l3{
				margin: 20px 0;
				img{
					width: 141px;
					height: 36px;
					
				}
			}
			.l4{
				color: #2D2A2A;
				font-size: 24px;
				margin-top: 20px;
				span{
					color: #7C7C7C;
					font-size: 20px;
					margin-left:10px;
				
				}
			}
			.l5{
				display: flex;
				margin-top: 20px;
				.cart-but{
					width: 131px;
					height:38px;
					line-height: 38px;
					background-color: #FB2C00;
					cursor: pointer;
					color: #FFFFFF;
					text-align: center;
					margin-left: 0px;
					
				}
			}
			.l6{
				margin-top: 20px;
				font-size: 14px;
			}
			.wishlist{
				border-top: 1px solid #dedede;
				margin-top: 20px;
				padding-top: 30px;
				color: #2D2A2A;
				font-weight: bolder;
				img{
					height: 20px;
					margin-right: 10px;
				}
				.co1{
					display: flex;
					margin-bottom: 20px;
				}
				.co2{
					display: flex;
				}
				
			}
		}
	}
	.product-bt{
		
		margin-top:20px;
		.tit{
			font-size: 22px;
			color: #2D2A2A;
			background: url(../../assets/bot1.png) no-repeat bottom left;
			padding-bottom: 20px;
			font-weight: bold;
		}
		.relat{
			margin-top: 40px;
		}
		.con{
	
			margin: 20px auto;
			width: 1200px;
			word-break: break-all;
		}
		
	}
}
.home-arr{
		.con{
			
			ul{
				display: block;
				li{
					
					width: 289px;
					height: 280px;
					float: left;
					margin-right:9px;
					.pic{
					
						height: 193px;
						
						img{
					
							height: 193px;
						
						}
					}
					.txt{
						font-size: 14px;
					}
				
				}
			
			
			}
		}
	}
</style>